module.exports = "https://99designs-start-assets.imgix.net/js/92329304f55e420ba7ab73ee7e4ded7b.svg";